





























import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class Confirm extends Vue {
  @Prop({ default: false, type: Boolean })
  visible!: boolean;

  // 点击确定
  handleOk(): void {
    (this as any).ok();
  }

  handleCancle(): void {
    (this as any).cancle();
  }

  handleClose(): void {
    (this as any).close();
  }
  
}
